import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import VueMultiSelect from 'vue-multiselect';

@Component({
    name: 'roster-subject-keywords',
    components: {
        'material-icons': GoogleMaterialIcon,
        'vue-multi-select': VueMultiSelect,
    },
})

export default class RosterSubjectKeywords extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop({ default: {} })
    private value: any;

    @Prop()
    private isReadOnly: any;

    @Prop()
    private categorySubjectData: any;

    private content: any = {};

    private isExpand: boolean = false;

    private indexNumber: number = 5;

    private categoryList: any = [];

    private dataPropsValues: any = [];

    private dataStringValue: any = '';

    private isLoading: any = false;

    private cateogryOptions: any = [];

    private selectedRecentItem: any = {};

    private subjectList: any = [];

    @Watch('categorySubjectData')
    private onWatchData(data: any) {
        if (data && data.length > 0) {
            this.fetchDisplayPropParent();
        }
    }
    // ---------------------------------------------------------------------
    // Methods

    private created() {
        this.content = this.value;
        if (!this.isReadOnly) {
            this.fetchCategoryList();
        }
    }

    private mounted() {
        if (this.categorySubjectData && this.categorySubjectData.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    private async fetchDisplayPropParent() {
        const categoryList = this.categorySubjectData;
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    keyValue: valueData[prop],
                    categoryId: propSplit[0],
                    subjectId: prop,
                    textString: valueData[prop].join(','),
                };
                dataValuesCalculate.push(data);
            }
        }
        for await (const [index, iterator] of dataValuesCalculate.entries()) {
            const selectedCategoryIndex = categoryList.findIndex((catItem: any) => {
                return catItem.code === iterator.categoryId;
            });
            if (selectedCategoryIndex !== -1) {
                const selectedSubjectIndex = categoryList[selectedCategoryIndex].subjectList.findIndex((item: any) => {
                    return item.id === iterator.subjectId;
                });
                const selectedSubject = categoryList[selectedCategoryIndex].subjectList[selectedSubjectIndex];
                iterator.subjectTitle = selectedSubject && selectedSubject.title ? selectedSubject.title : '--';
            }
        }
        this.dataPropsValues = dataValuesCalculate;
    }

    private getSubjectList(categoryId: string) {
        return taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            return subjectList;
        });
    }

    private makeStringToShow() {
        const dataValue = this.dataPropsValues;
        let emptyString = '';
        for (const iterator of dataValue) {
            emptyString += `${iterator.categoryId} - ${iterator.subjectTitle} | ${iterator.defaultFrameworkId} ; `;
        }
        this.dataStringValue = emptyString;
    }

    private showMore() {
        this.indexNumber = this.indexNumber + 5;
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }

    private fetchCategoryList() {
        // this.content = {"K12.MA":["mathematics", "maths"]};
        // this.value = this.content;
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    keyValue: valueData[prop],
                };
                dataValuesCalculate.push(data);
            }
        }
        this.isLoading = true;
        taxonomyAPI.fetchTaxonomyClassifications().then(async (categoryList: any) => {
            for await (const [index, iterator] of categoryList.entries()) {
                const subjectList = await taxonomyAPI.fetchSubjects(iterator.id);
                subjectList.filter((subject: any) => dataValuesCalculate.
                    findIndex((dataValue: any) => dataValue.keyName === subject.id) >= 0)
                    .forEach((selectedNewSubject: any) => {
                        selectedNewSubject.value = this.content[selectedNewSubject.id].toString();
                    });
                iterator.subjects = subjectList;
                if (index >= categoryList.length - 1) {
                    this.isLoading = false;
                    this.selectedRecentItem = categoryList[0];
                    this.subjectList = this.selectedRecentItem.subjects;
                    this.cateogryOptions = categoryList;
                }
            }
        });
    }

    private selectCategroy(item: any) {
        this.selectedRecentItem = item;
        this.subjectList = item.subjects;
    }

    private onUpdateText(itemInput: any) {
        const item = itemInput.code;
        this.value[itemInput.code] = itemInput.value.split(',');
        if (this.value[itemInput.code] && this.value[itemInput.code].length > 0) {
            this.$emit('input', this.value);
        } else {
            delete this.value[item];
        }
        this.$emit('input', this.value);
    }
}
